<template>
  <b-card>
    
    <div>
      <b-dropdown
        class="dropdown float-right mr-50"
        :text="filtroAnos"
        size="sm"
        variant="outline-danger"
      >
        <b-dropdown-item
          v-for="(tipo, index) in getAnoFiltros()"
          :key="index"
          @click="alterouFiltroAnos(tipo)"
        >
          {{ tipo.nome }}
        </b-dropdown-item>
      </b-dropdown>
      
      <b-dropdown
        class="dropdown float-right mr-50"
        :text="filtroMeses.data"
        size="sm"
        variant="outline-danger"
      >
        <b-dropdown-item
          v-for="(tipo, index) in meses"
          :key="index"
          @click="alterouFiltroMeses(tipo)"
        >
          {{ tipo.nome }}
        </b-dropdown-item>
      </b-dropdown>
      <h4>Cancelados</h4>
      
      <h2 class="font-weight-bolder mb-1">
        {{ items.length }}
      </h2>
      
      <div>
        <b-row>
          <b-button
            class="mx-1"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-danger"
            size="sm"
            @click="clicouVisualizar = !clicouVisualizar"
          >
            Visualizar
          </b-button>
        
        
        </b-row>
      </div>
    </div>
    
    <div v-if="clicouVisualizar" class="listaServicos">
      <hr class="mb-0" />
      <b-list-group flush>
        <b-list-group-item
          class="pb-0"
          v-for="(item, index) in items"
          :key="index"
        >
          <b-row class="font-small-3" :id="`popover-vencendo-info-${index}`">
            <b-col md="2" class="pr-0">
              <span>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  class="btn-icon"
                  :pressed="true"
                  :variant="
                    item.data_expiracao === $getDate.hoje()
                      ? 'flat-danger'
                      : 'flat-warning'
                  "
                >
                  <span>{{ item.id_company }}</span>
                </b-button>
              </span>
            </b-col>
            <b-col md="10">
              <ul class="list-unstyled">
                <li><strong>Nome</strong>: {{ item.nome }}</li>
                <li><strong>Tel Comercial:</strong> {{ item.tel_comercial }}</li>
                <li><strong>Celular: </strong>{{ item.celular_um }}</li>
                <li><strong>email:</strong> {{ item.email }}</li>
                <li><strong>Data Cancelamento</strong> {{ item.data_cancelamento | converteData }}</li>
              </ul>
            </b-col>
          </b-row>
        </b-list-group-item>
      </b-list-group>
    </div>
  </b-card>
</template>
<script>
import {
  BCard,
  BBadge,
  VBModal,
  BModal,
  BButton,
  BRow,
  BCol,
  BAvatar,
  BListGroup,
  BListGroupItem,
  BCardFooter,
  BDropdown,
  BDropdownItem,
  BPopover,
  VBPopover,
} from "bootstrap-vue";

import Ripple from "vue-ripple-directive";
import filtroMeses from "@/services/filtroMeses";
import filtroAnos from "@/services/filtroAnos";



export default {
  components: {
    BCard,
    BBadge,
    BModal,
    BButton,
    BRow,
    BCol,
    BAvatar,
    BListGroup,
    BListGroupItem,
    BCardFooter,
    BDropdown,
    BDropdownItem,
    BPopover,
    VBPopover,
  },
  directives: {
    Ripple,
    "b-modal": VBModal,
    "b-popover": VBPopover,
  },
  data() {
    return {
      clicouVisualizar: false,
      clicouOrdemOs: false,
      clicouOrdemData: false,
      ...filtroMeses,
      ...filtroAnos,
      filtroMeses: { valor: this.$getDate.mesAtual() , data: this.$getDate.nomeMesAtual() },
      filtroAnos: this.$getDate.anoAtual().toString(),
      items: []
    };
  },
  
  methods:{
    alterouFiltroMeses(val) {
      this.filtroMeses = { valor: val.value, data: val.nome }
      this.buscar()
    },
    alterouFiltroAnos(val) {
      this.filtroAnos = val.value.toString()
      this.buscar()
    },
    buscar() {
      this.$http.get(`adm/dashboard/cancelados/${this.filtroMeses.valor}/${this.filtroAnos}`).then((res) => {
        this.items = res.data
      })
    }
  },
  
  mounted() {
    this.buscar()
  },
  
  filters: {
    converteData(data) {
      if (!data) return;
      
      const d = data.split("-");
      return `${d[2]}/${d[1]}/${d[0]}`;
    },
  },
  
}
</script>
<style scoped>
.listaServicos {
  max-height: 400px;
  overflow-y: scroll;
}
</style>

